import { useEffect, useState } from "react";
import {
  getLocalStorageMenuItem,
  setLocalStorageMenuItem,
  setMobileButttonBackColor,
  setMobileCardColor,
  setMobileTextColor,
} from "../utility";
import { Container, Navbar } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { Form, Formik } from "formik";
import * as Yup from "yup";
import { Box, Button, Rating, TextField, TextareaAutosize } from "@mui/material";
import coverSample from "../images/No_Image_Available.jpg";
import no_image from "../images/No_Image_Available.jpg";
import Facebook from "../images/facebook-icon.svg";
import Twitter from "../images/twitter.svg";
import Instagram from "../images/instigram.svg";
import axios from "axios";
import Toast from "../common/toast";
import { useQuery } from "react-query";
import "../css/mobileScreens.css";
import Loading from "../common/loading";
import Processing from "../common/procsessing";
import { ArrowBackOutlined, ArrowForwardOutlined } from "@mui/icons-material";
import { t } from "i18next";

import Global from "../images/global.svg";
import FacebookDarkTheme from "../images/facebook-icon-dark-theme.svg";
import TwitterDarkTheme from "../images/x-icon-dark-theme.svg";
import InstagramDarkTheme from "../images/insta-icon-dark-theme.svg";
import GlobalDarkTheme from "../images/global-icon-dark-theme.svg";
import BottomNavBar from "../components/BottomNavBar";
import DOMPurify from 'dompurify';

const FeedBack = ({ tableQr, tableName }) => {
  const queryString = window.location.search;
  const urlParam = new URLSearchParams(queryString);

  const navigate = useNavigate();
  const lang = getLocalStorageMenuItem("lang");
  const [sending, setSending] = useState(true);
  const [value, setValue] = useState(0);
  const [toastSettings, setToastSettings] = useState({
    open: false,
    message: "",
    success: false,
  });

  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [isTablet, setIsTablet] = useState(window.innerWidth >= 768 && window.innerWidth < 1024);
  const [isDesktop, setIsDesktop] = useState(window.innerWidth >= 1024);

  // Add this useEffect for responsive detection
  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      setIsMobile(width < 768);
      setIsTablet(width >= 768 && width < 1024);
      setIsDesktop(width >= 1024);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleBack = () => {
    if (urlParam.get("section")) {
      navigate(
        `/${tableName}/${tableQr}/sections?section=${urlParam.get(
          "section"
        )}&t=${urlParam.get("t")}&lang=${getLocalStorageMenuItem("lang")}`
        , {
          replace: true
        });
    } else {
      navigate(
        `/${tableName}/${tableQr}/sections?section=0&t=${urlParam.get("t")}&lang=${getLocalStorageMenuItem("lang")}`
        , {
          replace: true
        });
    }
  };

  const handleBackHome = () => {
    navigate(
      `/${tableName}/${tableQr}/sections?section=0&t=${urlParam.get("t")}&lang=${getLocalStorageMenuItem("lang")}`
      , {
        replace: true
      });
  };

  const signInSchema = Yup.object().shape({
    email: Yup.string()
      .email(t("Invalid email"))
      .required(t("Email Is Required")),
    name: Yup.string()
      .min(2, t("Name Is Too Short"))
      .max(50, t("Name is Too Long"))
      .required(t("Name Is Required")),
    message: Yup.string().max(100, t("Message is Too Long")).notRequired(),
  });

  const handleSocialPage = (page) => {
    window.open(page, "_blank");
  };

  const onImageError = (e) => {
    e.target.src = coverSample;
  };

  const { data, isLoading, isFetching, isError, error } = useQuery(
    "public-details",
    async () => {
      try {
        const timeZone = getLocalStorageMenuItem("timezone") ? getLocalStorageMenuItem("timezone") : "";

        const promise = await axios.get(
          `${process.env.REACT_APP_API}/menus/${tableQr}/public-details`,
          { headers: { localization: getLocalStorageMenuItem("lang"), timeZone } }
        );
        if (promise.status === 200) {
          if (!getLocalStorageMenuItem("showOption")) {
            setLocalStorageMenuItem(
              "showOption",
              promise.data.data.mobile_settings?.showOption
            );
          }
          if (promise.data.data.mobile_settings?.theme === "costomize") {
            setLocalStorageMenuItem(
              "theme",
              promise.data.data.mobile_settings?.theme
            );
            setLocalStorageMenuItem(
              "textColor",
              promise.data?.data.mobile_settings.colorProps.text
            );
            setLocalStorageMenuItem(
              "backColor",
              promise.data?.data.mobile_settings.colorProps.back
            );
            setLocalStorageMenuItem(
              "cardColor",
              promise.data?.data.mobile_settings.colorProps.card
            );
            setLocalStorageMenuItem(
              "highlights",
              promise.data?.data.mobile_settings.colorProps.highlights
            );
            setLocalStorageMenuItem(
              "textOnHighlights",
              promise.data?.data.mobile_settings.colorProps.textOnHighlights
            );
          } else {
            if (
              getLocalStorageMenuItem("theme") !== "dark" &&
              getLocalStorageMenuItem("theme") !== "light"
            ) {
              setLocalStorageMenuItem(
                "theme",
                promise.data.data.mobile_settings?.theme
              );
            }
          }
        }
        return promise;
      } catch (error) { }
    }
  );

  const handleOpenToast = (rating_value) => {
    const toast = { ...toastSettings };
    toast.open = true;
    toast.success = true;

    if (rating_value === 5) {
      toast.success = true;
      toast.message = t(
        "Thank you so much for taking the time to leave us a 5 star rating - it's much appreciated!"
      );
    } else if (rating_value === 0) {
      toast.success = false;
      toast.message = t("Please choose reating");

    } else {
      toast.success = true;
      toast.message = t("Thanks for sharing your rating with us");
    }

    setToastSettings(toast);
  };

  const handleSubimt = async (values) => {

    if (!value) {
      setTimeout(() => handleOpenToast(value), 1000);;
    }
    setSending(false);
    const feedback = {
      menu_code: tableQr,
      stars: value,
      email: values.email,
      name: values.name,
      message: values.message,
    };

    try {
      const promise = await axios.post(
        `${process.env.REACT_APP_API}/messages`,
        feedback,
        {
          headers: {
            localization: lang,
          },
        }
      );
      if (promise.status === 200) {
        setSending(true);
        setTimeout(() => handleOpenToast(value), 1000);
        setTimeout(() => handleBack(), 3000);
      }
    } catch (error) {
      setSending(true);
    }
  };



  const handleCloseToast = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setToastSettings({ open: false, message: "", success: false });
  };

  if (isLoading) {
    return <Loading />;
  }
  const createSanitizedHTML = (html) => {
    return {
      __html: DOMPurify.sanitize(html || '')
    };
  };



  return (
    <div
      className={`min-vh-100 `}
      style={{ backgroundColor: setMobileCardColor() }}
    >
      <Container fluid>
        <div className="row">
          <div className={`${isDesktop ? '' : 'col-lg-4'}  ms-auto p-0`}>


            <div className={`p-24 ${isDesktop ? 'container' : ''}`} style={{ marginBottom: "60px" }}>
              <div className={isDesktop ? `slider-desktop-image` : `slider-mobile-image`} style={{
                position: 'relative',
                borderBottomLeftRadius: '20px',
                borderBottomRightRadius: '20px',
                height: 280
              }}>
                <img
                  src={data?.data.data.cover || coverSample}
                  onError={onImageError}
                  className="slider-mobile-image"
                />
                <Navbar
                  className={`d-flex justify-content-between align-items-center mobile-top-nav alignByLang`}
                  style={{ backgroundColor: setMobileCardColor() }}
                >
                  <Button
                    variant="text"
                    className={`ms-2 dark-color cursor`}
                    style={{ color: setMobileTextColor() }}
                    onClick={() => handleBack()}
                  >
                    {lang === "ar" || lang === "fr" ?
                      <ArrowForwardOutlined sx={{ color: setMobileTextColor() }} />
                      :
                      <ArrowBackOutlined sx={{ color: setMobileTextColor() }} />
                    }
                  </Button>

                  <Navbar.Brand className="text-center">
                    <img
                      src={data?.data.data.logo || no_image}
                      className="me-4 slider-mobile-logo cursor"
                      onError={onImageError}
                      onClick={handleBackHome}
                    />
                  </Navbar.Brand>
                </Navbar>
              </div>
              <ul className="d-flex justify-content-center list-unstyled">
                {data?.data.data.facebook && (
                  <li className="mx-2">
                    <img
                      onClick={() => handleSocialPage(data?.data.data.facebook)}
                      src={getLocalStorageMenuItem("theme") !== "light" ? FacebookDarkTheme : Facebook}
                      alt="Facebook icon"
                    />
                  </li>
                )}
                {data?.data.data.instagram && (
                  <li className="mx-2">
                    <img
                      onClick={() =>
                        handleSocialPage(data?.data.data.instagram)
                      }
                      src={getLocalStorageMenuItem("theme") !== "light" ? InstagramDarkTheme : Instagram}
                      alt="Instagram icon"
                    />
                  </li>
                )}
                {data?.data.data.twitter && (
                  <li className="mx-2">
                    <img
                      onClick={() => handleSocialPage(data?.data.data.twitter)}
                      src={getLocalStorageMenuItem("theme") !== "light" ? TwitterDarkTheme : Twitter}
                      alt="X icon"
                    />
                  </li>
                )}
                {data?.data.data.website && (
                  <li className="mx-2">
                    <img
                      onClick={() =>
                        handleSocialPage(data.data.data?.website)
                      }
                      src={getLocalStorageMenuItem("theme") !== "light" ? GlobalDarkTheme : Global}
                      alt="global icon"
                      className="cursor"
                    />
                  </li>
                )}
              </ul>
              <div className="text-center">
                <h1
                  className="mb-2 head-font"
                  style={{ color: setMobileTextColor(), marginTop: 40 }}
                >
                  {data?.data.data.venu_name}
                </h1>

                <Box
                  className="head-font"
                  style={{ color: setMobileTextColor() }}
                  dangerouslySetInnerHTML={createSanitizedHTML(data?.data.data.description)}

                />
              </div>

              <Formik
                initialValues={{
                  email: "",
                  name: "",
                  message: "",
                }}
                validationSchema={signInSchema}
                onSubmit={(values) => {
                  handleSubimt(values);
                }}
              >
                {({ errors, touched, values, setFieldValue }) => (
                  <Form>
                    <div className="text-center">

                      <Rating
                        name="no-value"
                        size="large"
                        value={value}
                        onChange={(event, newValue) => {
                          if (newValue) setValue(newValue);
                          else setValue(1);
                        }}
                        sx={{
                          '& .MuiRating-iconEmpty': {
                            color: setMobileTextColor()

                          }
                        }}
                      />
                    </div>
                    <div className="mt-4 mb-3 alignByLang">
                      <TextField
                        id="email"
                        name="email"
                        type="email"
                        variant="outlined"
                        value={values.email}
                        onChange={(e) => setFieldValue("email", e.target.value)}
                        placeholder={t("E-mail")}
                        helperText={errors.email && errors.email}
                        className="form-control rounded-2 head-font"
                        error={errors.email}
                        size="small"
                        sx={{
                          backgroundColor: setMobileCardColor(),
                          border: `1px solid #D0D5DD `,

                          minWidth: 300,
                          "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
                            borderColor: "#6BA5F2", // Change the border color on focus
                            color: setMobileTextColor(),

                          }
                          ,
                          "& .MuiInputBase-input": {
                            color: setMobileTextColor(),
                            fontFamily:
                              getLocalStorageMenuItem("lang") === "ar" ||
                                getLocalStorageMenuItem("lang") === "fa"
                                ? "Almarai"
                                : "Roboto",
                          }
                        }}
                        inputprops={{
                          style: {
                            color: setMobileTextColor(),
                            backgroundColor: setMobileCardColor(),
                          },
                        }}
                      />
                    </div>
                    <div className="mt-4 mb-3 alignByLang">
                      <TextField
                        id="name"
                        name="name"
                        type="text"
                        variant="outlined"
                        value={values.name}
                        onChange={(e) => setFieldValue("name", e.target.value)}
                        placeholder={t("Name")}
                        helperText={errors.name && errors.name}
                        className="form-control rounded-2 sub-font"
                        error={errors.name}
                        size="small"

                        sx={{
                          backgroundColor: setMobileCardColor(),
                          border: `1px solid #D0D5DD `,

                          minWidth: 300,
                          "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
                            borderColor: "#6BA5F2", // Change the border color on focus
                            color: setMobileTextColor(),
                          }
                          ,
                          "& .MuiInputBase-input": {
                            color: setMobileTextColor(),
                            fontFamily:
                              getLocalStorageMenuItem("lang") === "ar" ||
                                getLocalStorageMenuItem("lang") === "fa"
                                ? "Almarai"
                                : "Roboto",
                          }
                        }}
                        inputprops={{
                          style: {
                            color: setMobileTextColor(),
                            backgroundColor: setMobileCardColor(),
                          },
                        }}
                      />
                    </div>
                    <div className="mt-4 mb-3 alignByLang" >
                      <div className="input-group">
                        <TextareaAutosize
                          id="message"
                          name="message"
                          minRows={3}
                          className={`${errors.message && touched.message
                            ? "red-border"
                            : ""
                            }  form-control rounded-2 `}
                          style={{
                            resize: "none",
                            color: setMobileTextColor(),
                            backgroundColor: setMobileCardColor(),
                            border: `1px solid #D0D5DD `,
                            minWidth: "300px"
                          }}
                          value={values.message}
                          onChange={(e) =>
                            setFieldValue("message", e.target.value)
                          }
                          placeholder={t("What do you want to tell us")}
                          sx={{
                            backgroundColor: setMobileCardColor(),
                            border: `1px solid #D0D5DD `,

                            minWidth: 300,
                            "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
                              borderColor: "#6BA5F2", // Change the border color on focus
                              color: setMobileTextColor(),

                            }
                            ,
                            "& .MuiInputBase-input": {
                              color: setMobileTextColor(),
                              fontFamily:
                                getLocalStorageMenuItem("lang") === "ar" ||
                                  getLocalStorageMenuItem("lang") === "fa"
                                  ? "Almarai"
                                  : "Roboto",
                            }
                          }}
                          inputprops={{
                            style: {
                              color: setMobileTextColor(),
                              backgroundColor: setMobileCardColor(),
                            },
                          }}
                        />
                      </div>
                    </div>
                    {sending ? (
                      <Button
                        variant="outlined"
                        sx={{
                          backgroundColor: setMobileButttonBackColor(),
                          color: setMobileTextColor(),
                          borderColor: setMobileButttonBackColor(),
                        }}
                        className="d-block w-100 login-button head-font"
                        type="submit"
                      >
                        {t("Submit")}
                      </Button>
                    ) : (
                      <Processing text={t("Loading...")} fullWidth={true} />
                    )}
                  </Form>
                )}
              </Formik>
            </div>
          </div>
          <Toast
            open={toastSettings.open}
            message={toastSettings.message}
            handleClose={handleCloseToast}
            success={toastSettings.success}
          />
        </div>
      </Container>
      <BottomNavBar qr={tableQr} qrName={tableName} />

    </div>
  );
};

export default FeedBack;
